import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import LazyThumb from '../common/helpers/lazy-thumb';

import './404-content.scss';

export default function FileNotFoundSection() {
  const data = useStaticQuery(graphql`
    query FourOFourPageQuery {
      csFileNotFound404Page {
        page_content {
            header
            copy
            header_image {
                url
            }
        }
      }
    }
  `);

  return (
    <div className="four-o-four-section padding-bottom">
      <div className="max-width padding-top">
        <LazyThumb className="file-not-found-image" src={data.csFileNotFound404Page.page_content.header_image ? data.csFileNotFound404Page.page_content.header_image.url : ''}/>
        <h2>{data.csFileNotFound404Page.page_content.header}</h2>
        <div className="wysywig" dangerouslySetInnerHTML={{ __html: data.csFileNotFound404Page.page_content.copy }}></div>
                
      </div>
    </div>
  );
}
